





// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// Third Party
import dayjs, { UnitType } from 'dayjs';
import 'dayjs/locale/es';

// Models
import { Budget } from '@/manager/budget/models/budget.model';
import { BudgetLine } from '@/manager/budget/models/budget-line.model';
import { Client } from '@/manager/client/client.model';

// Constants
import Assets from '@/constants/assets.ts';
import Constants from '@/constants/constants.ts';

// Components
import Btn, {
  BtnColor,
  BtnWidth,
  BtnPredefinedStyle,
} from '@/shared/components/btn.component.vue';
import CheckIcon, {
  CheckIconColor,
} from '@/shared/components/CheckIcon.component.vue';
import Field from '@/shared/components/field.component.vue';
import FieldSet from '@/shared/components/field-set.component.vue';
import { IconEnum } from '@/shared/components/icon.component.vue';
import Input, { InputType } from '@/shared/components/input.component.vue';
import SearchAutocomplete from '@/shared/components/SearchAutocomplete.component.vue';
import TextArea from '@/shared/components/text-area.component.vue';
import TopModal from '@/shared/components/TopModal.component.vue';
import FlatSelectorText, {
  FlatSelectorTextPredefinedStyle,
  FlatSelectorTextBorderBottom,
  FlatSelectorTextWeight,
} from '@/shared/components/FlatSelectorText.component.vue';
import InlineSpinner, {
  SpinnerSize,
} from '@/shared/components/inline-spinner.component.vue';
import ChoosePaymentMethod from '@/client/budget/views/acceptance/choose-payment-method/index.vue';
import SpotlightText, {
  SpotlightTextColor,
} from "@/shared/components/SpotlightText.component.vue";
import Dropdown, {
  DropdownWidth,
  DropdownStyle
} from "@/shared/components/Dropdown.component.vue";
import Modal, {
  ModalTitleColor,
} from "@/shared/components/Modal.component.vue";

// Views
import ShoppingCartBudget from '@/manager/budget/views/edit-budget-modal/shopping-cart/index.vue';
import {
  BudgetPaymentMethod,
  BudgetPaymentStatus,
} from '@/manager/budget/models/budget.model';

// Mixins
import SearchMixin from '@/shared/mixins/search.mixin.ts';
import ErrorMixin from '@/shared/mixins/error.mixin.ts';

// Services
import UtilsService from '@/core/services/utils.service';
import {
  ConvocationService,
  TypeOfProduct,
} from '@/manager/convocation/convocation.service';
import NotificationMessage from '@/shared/mixins/notificationMessage.mixin.ts';

//filters
import formatDate from "@/shared/filters/formatDate.filter.ts";

interface MixinInterface extends ErrorMixin, SearchMixin, NotificationMessage { }

@Component({
  components: {
    Btn,
    CheckIcon,
    Field,
    FieldSet,
    FlatSelectorText,
    InlineSpinner,
    Input,
    SearchAutocomplete,
    ShoppingCartBudget,
    Modal,
    TextArea,
    TopModal,
    ChoosePaymentMethod,
    SpotlightText,
    Dropdown
  },
  methods: {
    ...mapActions({
      setCurrentBudget: 'setCurrentBudget',
      setCurrentBudgetAcceptance: 'setCurrentBudgetAcceptance',
    }),
  },
  filters: {
    formatDate
  },
  computed: {
    ...mapGetters({
      getProfile: 'getProfile',
      clientList: 'getClientList',
      getProcedencyList: 'procedencyList',
      delegationList: 'getDelegationList',
      getDelegation: 'getDelegation',
      getProduct: 'getProduct',
      budget: 'getCurrentBudget',
      editingBudget: 'editingCurrentBudget',
      hasLineProduct: 'currentBudgetHasLineProduct',
      currentBudget: 'getCurrentBudgetAcceptance',
      isCardMethodSelected: 'isCardMethodSelectedInCurrentBudgetAcceptance',
      isDirectDebitMethodSelected:
        'isDirectDebitMethodSelectedInCurrentBudgetAcceptance',

    }),
  },
})
export default class EditBudgetModal extends Mixins<MixinInterface>(
  ErrorMixin,
  SearchMixin,
  NotificationMessage
) {
  @Prop() private id!: string;
  @Prop({ default: true }) private opened!: boolean;
  @Prop({ default: false }) private modifyDataPrivateModal!: boolean;

  private dropdownWidth = DropdownWidth;
  private DropdownStyle = DropdownStyle;
  private assets = Assets;
  private btnColor = BtnColor;
  private btnWidth = BtnWidth;
  private btnPredefinedStyle = BtnPredefinedStyle;
  private iconEnum = IconEnum;
  private inputType = InputType;
  private checkIconColor = CheckIconColor;
  private spinnerSize = SpinnerSize;
  private utilsService = UtilsService;
  private getProfile!: any;
  private lastNoteTyped: string = '';
  private selectedClient: any | null = null;
  private clientList!: Client[];
  private getProcedencyList!: any;
  private delegationList!: any;
  private getProduct!: any;
  private editingBudget!: any;
  private budget!: any;
  private hasLineProduct!: any;
  private setCurrentBudget!: any;
  private setCurrentBudgetAcceptance!: any;
  private getDelegation!: any;
  private newClient: Client = new Client();
  private nifMask = '';
  private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
  private flatSelectorTextBorderBottom = FlatSelectorTextBorderBottom;
  private flatSelectorTextWeight = FlatSelectorTextWeight;
  private procedencyOptions: any = [];
  private procedencySelected: any = {};
  private procedencyOption: any = {
    value: '0',
    label: '',
  };
  private serverError = '';
  private infoMsg = '';
  public error = {
    delegation: '',
  };
  private modalTitleColor = ModalTitleColor;
  private requestPending = false;
  private cambioDatosTextoConfirmacion: string = "Gracias, los datos han sido registrados. En adelante, se usará este método de pago para este producto."
  private disableSendForm = false;

  private currentBudget?: any;
  private isCardMethodSelected!: any;
  private isDirectDebitMethodSelected!: any;
  private newPaymentAdded: any = false;
  private clientPayments: any
  private clientPaymentSelected: any = this.clientPayments ? this.clientPayments[0] : '';
  private showNewPaymentMethod = false
  private previousPaymentMethod: any;
  private showAddPaymentInfoBoolean: any = false;
  private sendAdminEmailModalOpened: any = false;
  private sendEmail: boolean = false;

  private toggleSendAdminEmailModalOpened(value: boolean) {
    this.sendAdminEmailModalOpened = value;
  }

  private setPreviousPaymentMethod() {
    var clientPaymentId = this.budget.creditCard ? this.budget.creditCard.id : this.budget.bankAccount ? this.budget.bankAccount.id : undefined;
    if (this.clientPayments && clientPaymentId) {
      this.previousPaymentMethod = this.clientPayments.filter((item: any) => item.id == clientPaymentId)[0]

      if (!this.previousPaymentMethod) {
        this.fetchClientPaymentDetail(clientPaymentId, 0)
      }

    } else {
      this.previousPaymentMethod = undefined
    }
    this.$forceUpdate();
  }


  @Watch('opened')
  private watchOpened(newVal: any, oldVal: any) {
    this.checkFillModalWithBudgetData();
    if (newVal) {
      this.fetchClientPayment(0);
    }
  }

  @Watch('serverError')
  private watchServerError(newVal: any, oldVal: any) {
    if (newVal != this.cambioDatosTextoConfirmacion) {
      setTimeout(() => {
        this.serverError = '';
      }, Constants.notificationMessageTimeToAppear);
    }
  }

  @Watch('infoMsg')
  private watchInfoMsg(newVal: any, oldVal: any) {
    setTimeout(() => {
      this.serverError = '';
    }, Constants.notificationMessageTimeToAppear);
  }

  private created() {
    this.remainingTime = 0;
    this.fetchDelegationList();
    this.fetchProcedency();
  }

  get hasSelectedClient() {
    return this.selectedClient !== null;
  }

  get lastSectionTitle() {
    let title = '';
    if (!this.editingBudget) {
      title = 'Añadir nota';
    }
    return title;
  }

  get hasServerError() {
    return this.serverError !== '';
  }

  get hasInfoMsg() {
    return this.infoMsg !== '';
  }

  get modalTitle() {
    let title = 'Añadir alta';
    if (this.modifyDataPrivateModal) {
      title = 'Cambio datos de pago aplazable: Bloque no editable'
    } else if (this.editingBudget) {
      title = 'Editar alta';
    }
    return title;
  }

  get btnText() {
    let text = 'Añadir alta';
    if (this.modifyDataPrivateModal) {
      text = "Guardar y enviar"
    } else if (this.editingBudget) {
      text = 'Guardar';
    }
    return text;
  }

  get formComplete() {
    return (
      this.budget.client.user &&
      this.budget.client.user.id !== undefined &&
      this.budget.delegation !== undefined &&
      this.budget.budgetLine[0] &&
      this.budget.budgetLine[0].product &&
      this.budget.budgetLine[0].product.id !== undefined
    );
  }

  get isPublicView() {
    return window.location.href.includes("/public/")
  }

  private fetchBudget(budgetId: any) {
    this.$store.dispatch("fetchBudget", { id: budgetId }).then(
      res => {
        this.setCurrentBudget(res)
        this.modifyDataPrivateModal = true
        this.budget = res
        this.fetchClientPayment(0)
        this.checkFillModalWithBudgetData()

        setTimeout(() => {
          this.$forceUpdate();
        }, 300);
      }
    );
  }

  public searchCallback() {
    if (this.searchString === '') {
      this.selectedClient = null;
    }
    this.fetchClientList();
  }

  private isLetter(str: string) {
    return str.length === 1 && str.match(/[a-zA-Z]/i);
  }

  private isNumber(str: string) {
    return str.length === 1 && str.match(/[0-9]/i);
  }

  private fetchClientList() {
    const payload = {
      limit: 20,
      search: this.searchString,
    };
    this.$store.dispatch('fetchClientList', payload);
  }

  private closeModal() {
    this.cleanData()
    if (this.opened) {
      this.$emit('close-modal-edit-budget', true);
    }
  }

  private cleanData() {
    this.clientPayments = undefined
    this.clientPaymentSelected = undefined
    this.newPaymentAdded = false
    this.showNewPaymentMethod = false
  }

  private checkMandatoryFields() {
    let result = true;

    if (!this.budget.client.user.id) {
      this.serverError = 'Se debe seleccionar un cliente';
      result = false;
    } else if (!this.budget.delegation) {
      this.serverError = 'Se debe seleccionar una delegación';
      result = false;
    } else if (!this.hasLineProduct) {
      this.serverError = 'El alta debe tener al menos un producto';
      result = false;
    }
    return result;
  }

  private setParticipantFormError(err: any) {
    const serverError = err.response.data;
    const response = err.response;
    this.requestPending = false;
    if (
      response.status === 500 ||
      (response.status === 400 && serverError.nonFieldErrors !== undefined)
    ) {
      this.serverError = Constants.internalServerErrorMessage;
    }
  }

  private setIdProductInBudgetLines(budget: Budget) {
    const newLines = (budget as any).budgetLine.map((line: BudgetLine) => {
      const budgetLine = Object.assign({}, line);
      const productId = (budgetLine.product as any).id;
      delete budgetLine.product;
      return {
        product: productId,
        ...budgetLine,
      };
    });
    budget.budgetLine = newLines;
  }

  private checkBudget() {
    const newBudget = Object.assign({}, this.budget);
    newBudget.budgetLine = Object.assign([], newBudget.budgetLine);
    const budgetLines = (newBudget as any).budgetLine.length;

    if (budgetLines > 0) {
      (newBudget as any).budgetLine.pop();
      this.setIdProductInBudgetLines(newBudget);
    }
    newBudget.delegation = newBudget.delegation.id;
    delete newBudget.bankAccount;
    delete newBudget.bill;
    delete newBudget.creditCard;

    return newBudget;
  }

  private newBudget() {
    const budget = this.checkBudget();
    const note = { note: this.lastNoteTyped };

    this.$store
      .dispatch('newBudget', {
        ...budget,
        note,
        new_payment_method_email: this.sendEmail
      })
      .then((res) => {
        this.sendEmail = false
        this.closeModal();
        this.initializeBudget();
        setTimeout(() => {
          this.$emit('new-budget', { add: true, edit: false });
        }, 300);
        this.requestPending = false;
        if (this.modifyDataPrivateModal && this.isPublicView) {
          this.requestPending = false
          this.infoMsg = this.cambioDatosTextoConfirmacion
        }
      })
      .catch((err) => {
        this.setParticipantFormError(err);
      });
  }

  private updateBudget() {
    const budget = this.checkBudget();

    this.$store
      .dispatch('updateBudget', {
        clientPaymentMethod: this.clientPaymentSelected ? this.clientPaymentSelected.id : '',
        ...budget,
        new_payment_method_email: this.sendEmail
      })
      .then((res) => {
        this.sendEmail = false;
        this.closeModal();
        this.initializeBudget();
        setTimeout(() => {
          this.$emit('new-budget', { add: false, edit: true });
        }, 300);
        this.requestPending = false;
        if (this.modifyDataPrivateModal && this.isPublicView) {
          this.infoMsg = this.cambioDatosTextoConfirmacion
        }
      })
      .catch((err) => {
        this.setParticipantFormError(err);
      });
  }

  private sendEmailAdmin(send_email: any = undefined) {
    this.sendEmail = send_email
    this.toggleSendAdminEmailModalOpened(false)
    this.sendForm()
  }

  private sendForm() {
    this.toggleSendAdminEmailModalOpened(false)
    if (this.checkMandatoryFields()) {
      this.requestPending = true;
      if (this.editingBudget) {
        this.updateBudget();
      } else {
        this.newBudget();
      }
    }
  }

  private selectClient(option: any) {
    this.selectedClient = option;
    (this.newClient as any).user.profile.nif = '';
    setTimeout(() => {
      this.fillWithClientData();
    }, 100);
  }

  private clearClient() {
    this.selectedClient = null;
    this.newClient = new Client();
  }

  private initializeBudget() {
    this.setCurrentBudget(new Budget());
    this.clearClient();
    this.lastNoteTyped = '';
  }

  private checkAddEmptyBudgetLine() {
    const lines = (this.budget as any).budgetLine;
    const linesLength = lines.length;
    if (lines[linesLength - 1].id) {
      const newLine = new BudgetLine();
      lines.push(newLine);
    }
  }

  private setBudgetLineProductObject() {
    (this.budget as any).budgetLine.forEach((line: any) => {
      if (!line.product.id) {
        line.product = this.getProduct(line.product);
      }
    });
    this.checkAddEmptyBudgetLine();
  }

  private setBudgetDelegationObject() {
    const delegationId = this.budget.delegation;
    this.budget.delegation = this.getDelegation(delegationId);
  }

  private checkFillModalWithBudgetData() {
    if (this.opened && this.editingBudget) {
      this.newClient = this.budget.client as any;
      this.setBudgetLineProductObject();
      this.setBudgetDelegationObject();
    } else if (this.opened && !this.editingBudget) {
      this.newClient = new Client();
    }
  }

  private fillWithClientData() {
    if (this.selectedClient !== null) {
      const client = this.$store.getters.getClient(this.selectedClient.id);
      this.newClient = client;
      this.budget.client = client;
    }
  }

  private parseProcedencyToFlatSelectorTextOption(procedencyList: any) {
    this.procedencyOptions = procedencyList.map((procedency: any) => {
      const option = {
        value: procedency.id,
        label: procedency.name,
      };
      return option;
    });
  }

  private fetchProcedency() {
    this.$store.dispatch('fetchProcedency').then((res) => {
      this.parseProcedencyToFlatSelectorTextOption(this.getProcedencyList);
    });
  }

  private fetchDelegationList(
    callback: any = () => {
      const doNothing = 1;
    },
  ) {
    this.$store.dispatch('fetchDelegationList').then((res: any) => {
      callback();
      if (this.id) {
        this.fetchBudget(this.id);
      }
    });
  }



  @Watch("clientPaymentSelected")
  private watchClientPaymentSelected(newVal: any, oldVal: any) {
    if (newVal != undefined && newVal.active == false) {
      this.showNewPaymentMethod = true
      this.updateClientPayment(newVal)
    }
  }


  private updateClientPayment(newVal: any) {
    newVal.active = true
    this.$store
      .dispatch("updateClientPayment", {
        id: this.budget.client.user.id,
        viewStatus: 0,
        budget: this.currentBudget.id,
        ...newVal
      })
      .then((res) => {
        if (res.message != '') {
          this.showNotification(res.message);
          this.fetchClientPayment(0)
        }
      })
      .catch((err) => {
        this.showNotification(err.error, SpotlightTextColor.Error);
      });
  }

  private fetchClientPaymentDetail(id: any, viewStatus: number) {
    this.$store
      .dispatch("fetchClientPaymentDetail", { id: id, viewStatus: viewStatus })
      .then((res) => {
        this.previousPaymentMethod = res.data[0]
        this.$forceUpdate();
      });
  }

  private fetchClientPayment(viewStatus: number) {
    this.$store
      .dispatch("fetchClientPayment", { id: this.budget.client.user.id, viewStatus: viewStatus })
      .then((res) => {
        this.clientPayments = res.data.filter((item: any) => item.status != 1)
        this.clientPaymentSelected = this.clientPayments.filter((item: any) => item.active)[0]
        if (!this.clientPaymentSelected) {
          this.clientPaymentSelected = this.clientPayments[0]
        }
        this.setPreviousPaymentMethod()
        if (res.info != '') {
          this.showNotification(res.info, SpotlightTextColor.Error);
        }
      });
  }

  get creditCardFormated() {
    const creditCard = Object.assign({}, this.currentBudget.creditCard);
    const splittedDate = creditCard.dateExpiration.split('/');
    const month = Number(splittedDate[0]) - 1;

    let dateDayjs = dayjs();
    let year = dateDayjs.year().toString();
    year = year.substring(0, year.length - 2);
    year += splittedDate[1];
    dateDayjs = dateDayjs
      .set('date', 1)
      .set('month', month)
      .set('year', Number(year));
    creditCard.dateExpiration = dateDayjs.toISOString();
    if (!creditCard.relatedProduct) {
      creditCard.relatedProduct = this.currentBudget.budgetLine.length > 0 && this.currentBudget.budgetLine[0].product && this.currentBudget.budgetLine[0].product.name ? this.currentBudget.budgetLine[0].product.name : undefined
    }
    return creditCard;
  }

  private getPaymentInfo() {
    let info = {};
    if (this.isCardMethodSelected) {
      info = { creditCard: this.creditCardFormated };
    } else if (this.isDirectDebitMethodSelected) {
      // const bankId = this.currentBudget.bankAccount.bank.id;
      // this.currentBudget.bankAccount.bank = bankId;
      if (process.env.VUE_APP_DEBUG) {
        // this.currentBudget.bankAccount.bank = "572a9108-f910-4cb6-942c-cedb529e29e3";
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      } else {
        // this.currentBudget.bankAccount.bank = "7591c2a8-691c-4862-aa57-fc374e9117a2";
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      }
      if (!this.currentBudget.bankAccount.relatedProduct) {
        this.currentBudget.bankAccount.relatedProduct = this.currentBudget.budgetLine.length > 0 && this.currentBudget.budgetLine[0].product && this.currentBudget.budgetLine[0].product.acronym ? this.currentBudget.budgetLine[0].product.acronym : undefined
      }
      info = { bankAccount: this.currentBudget.bankAccount };
    }
    return info;
  }

  private showAddPaymentInfo(value: Boolean) {
    if (value == true) {
      this.setCurrentBudgetAcceptance(new Budget());
    }
    this.showAddPaymentInfoBoolean = value;
  }

  private addPaymentInfo() {
    if (this.checkFormValidation()) {
      this.newPaymentAdded = true
      let errorNotification = null;
      let holder = null;

      if (this.isCardMethodSelected) {
        holder = this.currentBudget.creditCard.holder;
      } else if (this.isDirectDebitMethodSelected) {
        holder = this.currentBudget.bankAccount.holder;
      }

      if (holder && this.budget.client.user.fullName !== holder) {
        errorNotification = "El nombre del titular ha de ser igual al NOMBRE del cliente actual";
      }

      if (errorNotification) {
        this.showNotification(errorNotification, SpotlightTextColor.Error);
        this.newPaymentAdded = false
      } else {
        this.showAddPaymentInfo(false)
        this.$store
          .dispatch("newClientPayment", { id: this.budget.client.user.id, viewStatus: 0, ...this.getPaymentInfo() })
          .then((res) => {
            this.showNotification(res.message);
            this.fetchClientPayment(0)
            this.newPaymentAdded = false;
            this.currentBudget.bankAccount = {}
            this.currentBudget.creditCard = {}
          })
          .catch((err) => {
            this.showNotification(err.message, SpotlightTextColor.Error);
            this.newPaymentAdded = false
          });
      }
    }
  }

  private checkFormValidation() {
    if (
      this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.DirectDebit.toString()
    ) {
      return this.directDebitFieldsValidation();
    } else if (
      this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.Card.toString()
    ) {
      return this.cardFieldsValidation();
    }
  }

  private directDebitFieldsValidation() {
    if (this.currentBudget.bankAccount) {
      const error: any = { bankAccount: {}, budgetSepaInfo: {} };
      const emptyField = 'Campo vacío';
      const errorField = 'Campo incorrecto';
      var errores = false
      // if (!(this.currentBudget.bankAccount as any).bank) {
      //   error.bankAccount['bank'] = emptyField;
      // }
      const bankNumber = (this.currentBudget.bankAccount as any).number;
      if (!bankNumber) {
        error.bankAccount['number'] = emptyField;
        errores = true
      } else if (bankNumber.trim().length < 24) {
        error.bankAccount['number'] = errorField;
        errores = true
      }
      if (!(this.currentBudget.bankAccount as any).holder) {
        error.bankAccount['holder'] = emptyField;
        errores = true
      }
      if (!(this.currentBudget.bankAccount as any).number) {
        error.bankAccount['number'] = emptyField;
        errores = true
      }

      if (errores) {
        this.setAcceptanceFieldError(error);
        return false
      } else {
        return true
      }
    }
  }

  private cardFieldsValidation() {
    if (this.currentBudget.creditCard) {
      const error: any = { creditCard: {} };
      const emptyField = 'Campo vacío';
      const errorField = 'Campo incorrecto';
      var errores = false

      const cardNumber = (this.currentBudget.creditCard as any).number;
      if (!cardNumber) {
        error.creditCard['number'] = emptyField;
        errores = true
      } else if (cardNumber.trim().length < 16) {
        error.creditCard['number'] = errorField;
        errores = true
      }
      const dateExpiration = (this.currentBudget.creditCard as any)
        .dateExpiration;
      if (!dateExpiration) {
        error.creditCard['dateExpiration'] = emptyField;
        errores = true
      } else if (dateExpiration.trim().length < 5) {
        error.creditCard['dateExpiration'] = errorField;
        errores = true
      }
      const cvv = (this.currentBudget.creditCard as any).cvv;
      if (!cvv) {
        error.creditCard['cvv'] = emptyField;
        errores = true
      } else if (cvv.trim().length < 3) {
        error.creditCard['cvv'] = errorField;
        errores = true
      }
      if (!(this.currentBudget.creditCard as any).holder) {
        error.creditCard['holder'] = emptyField;
        errores = true
      }

      if (errores) {
        this.setAcceptanceFieldError(error);
        return false
      } else {
        return true
      }
    }
  }

  private setAcceptanceFieldError(error: any) {
    const newError = error;
    this.$store.commit('setAcceptanceFieldError', newError);
  }

  private copyHolderName() {
    if (this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.DirectDebit.toString()) {
      this.currentBudget.bankAccount.holder = this.budget.client.user.fullName
    } else if (this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.Card.toString()) {
      this.currentBudget.creditCard.holder = this.budget.client.user.fullName
    }

    this.setCurrentBudgetAcceptance(this.currentBudget)

    // Forzar refresco de los componentes hijos
    const choosePaymentMethodComponent = this.$refs.componentePagoAplazado as ChoosePaymentMethod
    if (choosePaymentMethodComponent.$children) {
      choosePaymentMethodComponent.$children.forEach((child: any) => {
        child.$forceUpdate()
      });
    }
  }
}
